import '../styles/landing-page.css';

export default function FeatureCard({ title, subtitle, image, href }) {
  return (
    <a className="feature-card" href={href}>
      <div className="feature-card-image-wrap">
        <img alt="" className="feature-card-image" src={image} />
      </div>
      <div className="feature-card-body">
        <p className="feature-card-title">{title}</p>
        <p className="feature-card-subtitle">{subtitle}</p>
        <p className="feature-card-cta">Call to action →</p>
      </div>
    </a>
  );
}
